import React from "react";
import DefaultVariant from "./components/DefaultVariant";
import AlertVariant from "./components/AlertVariant"
import CustomerSupportLanding from "./components/CustomerSupportLanding";

type CardImageTextReactTypes = {
  DomPurify: Function;
  translatedData: {
    imageUrl: string;
    imageAltText: string;
    imageWidth: string;
    imageHeight: string;
    header: string;
    paragraph: string;
    linkText: string;
    linkUrl: string;
    linkAriaLabel: string;
    cardImageType:string;
  };
};

export default function CardImageTextReact(props: CardImageTextReactTypes) {
  console.log(props.translatedData);
  const isDIB = props.translatedData.cardImageType === "alerts"
  const isCustomerSupport = props.translatedData.cardImageType === "customerSupport"
  if(isDIB){
   return <AlertVariant {...props} />;
  } else if (isCustomerSupport) {
    return <CustomerSupportLanding  {...props}/>
  }else {
  return <DefaultVariant {...props} />;
  }
}
